export type ClinicOption = {
  value: string;
  label: string;
};

/** Stable ordering shared by clinic controls and their default selections. */
export const compareClinicOptions = (
  a: Pick<ClinicOption, 'value' | 'label'>,
  b: Pick<ClinicOption, 'value' | 'label'>
): number =>
  a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }) ||
  a.value.localeCompare(b.value);
